// Virtual Car
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './publicPath';
import './v1/styles/index.scss';
import './v2/styles/index.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';

const { USE_AEM_PROXY } = process.env;

if (USE_AEM_PROXY === 'true') {
    const getSelectors = () => ({
        application: 'http://localhost:3333/data.virtualCarAppData.application.json',
        home: 'http://localhost:3333/data.virtualCarData.home.json',
        menu: 'http://localhost:3333/data.virtualCarAppData.application.menu.json',
        serenely: 'http://localhost:3333/data.virtualCarData.serenely.json',
        effortlessly: 'http://localhost:3333/data.virtualCarData.effortlessly.json',
        powerfully: 'http://localhost:3333/data.virtualCarData.powerfully.json',
        smartly: 'http://localhost:3333/data.virtualCarData.smartly.json',
    });

    window.HELIOS = {
        adobe: {
            shared: {},
            tagging: {
                targetCode: 'nissanhelioseu',
                googleAccount: '',
                adobeAccount: 'nissanukprod',
                mboxActivated: 'false',
                pageName: 'virtual-car',
                countryCode: 'GB',
                languageCode: 'en',
                vehicleId: 'PZ1A',
                pageType: 'vehicle',
                vehicleModel: 'Ariya',
                vehicleCategory: 'Electric SUV',
                loginStatus: 'logged out',
                vcStep: 'home',
                componentId: 'c314_virtual_car',
                toolName: 'virtual car',
            },
        },
        publicPath: '/',
        aemBasePath: '/virtual-car.html',
        config: {
            'buildVersion-XT': '20.05.4.NISSAN-SNAPSHOT.build-2',
            'buildVersion-AEM': '20.05.4.NISSAN-SNAPSHOT.build-2',
        },
        selectors: getSelectors(),
    };
}

ReactDOM.render(<App />, document.getElementById('root'));
